import { motion } from "framer-motion";

export default function BrandLogo({ compact = false, dark = false, className = "", src }) {
  return (
    <motion.img
      animate={{ opacity: 1 }}
      className={`brand-logo ${compact ? "brand-logo--compact" : ""} ${className}`}
      data-testid={compact ? "brand-icon" : "brand-full-logo"}
      src={src || (dark ? "/brand/logo-light.webp" : "/brand/logo-dark.webp")}
      alt="Urban Motors"
    />
  );
}